import { adConfigReceived, adConfigUnloaded } from 'redux-implementations/carGurusAds';
import { useDispatch } from 'react-redux';
import { useDeepCompareEffect } from 'react-use';
import { AgeType } from 'lib/CarGurusAds/TaxonomySchema';
import { Targeting } from '../CarGurusAds';

export function calculateAgeType(year: string | undefined): AgeType {
  if (!year) {
    return AgeType.None;
  }

  const yr = parseInt(year, 10);
  const currentYear = new Date().getFullYear();
  if (yr >= currentYear - 2) {
    return AgeType.New;
  }
  if (yr === currentYear - 3) {
    return AgeType.NewPlus;
  }
  if (yr > currentYear - 11 && yr <= currentYear - 3) {
    return AgeType.Used;
  }
  if (yr <= currentYear - 11) {
    return AgeType.Classic;
  }
  return AgeType.None;
}

export default function useCarGurusAdSetup(adUnit: string, targeting: Targeting): void {
  const dispatch = useDispatch();

  useDeepCompareEffect(() => {
    dispatch(
      adConfigReceived({
        adTargeting: {
          ...targeting,
        },
        adUnit,
      })
    );

    return (): void => {
      dispatch(adConfigUnloaded());
    };
  }, [adUnit, dispatch, targeting]);
}
